import React from "react";
import img from "../Assets/n1.jpg";
import img2 from "../Assets/n2.jpg";
import img3 from "../Assets/n3.jpg";
import img4 from "../Assets/n4.jpg";
import img5 from "../Assets/n5.jpg";

const reelImages = [img, img2, img3, img4, img5];

function HowPvt() {
  return (
    <>
      <div className="howworks">
        <div className="howworks-left">
          <div className="video-box">
            <div className="video-box-inner">
              {[0, 1].map((groupIndex) => (
                <div className="video-box-group" key={groupIndex} aria-hidden={groupIndex === 1}>
                  {reelImages.map((image, index) => (
                    <img
                      key={`${groupIndex}-${index}`}
                      src={image}
                      alt="Private theater celebration preview"
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="howworks-right">
          <h3>How Does Private Theater Celebration Work?</h3>
          <p>
            {/* Planning your private theater celebration with The Cine Celebrate is
            simple and hassle-free. Start by selecting your preferred date and
            time, then choose from our customizable packages to suit your
            occasion. Whether it’s a birthday, date night, or anniversary, you
            can add personalized touches like décor, or even a photoshoot. On
            the day of your event, enjoy a seamless experience as you watch your
            favorite movies, shows, photos, or videos on the big screen,Sit
            back, relax, and let us take care of the details to make your
            celebration truly unforgettable! */}
            {/* At Cine Celebrate, planning a private theater celebration is as
            seamless as it is exciting. Whether you’re organizing a birthday
            party, anniversary surprise, romantic date night, or a bride-to-be
            bash, our platform lets you design the perfect cinematic experience
            with just a few clicks. Start by selecting your preferred date, time
            slot, and private theater room—choose from our beautifully themed
            Sapphire, Pearl, or Diamond rooms based on your vibe and guest
            count. */}
            Planning a private theater celebration at Cine Celebrate isn’t complicated at all. Most people reach out to us when they’re looking for something different - maybe after searching for birthday locations near me or anniversary celebration places near me or private theater near me, and finding the usual banquet halls. If you want a private theater in Delhi that feels personal instead of crowded, this works beautifully.

            <br />
            <br />
            {/* Once you've secured your private movie theater booking, you'll be
            guided to explore a wide range of customizable add-ons such as
            balloon decorations, LED light setups, happy birthday neon signs,
            photoshoots, cakes, food and beverage packages, and even
            personalized proposal settings. Our goal is to transform your
            celebration into a blockbuster experience that feels intimate,
            luxurious, and tailored just for you. */}
            First, you pick your date and time slot. After that, you choose your private theater room - Sapphire, Pearl, or Diamond - depending on the mood and number of guests. Some couples book it simply for a romantic date night, while others plan full birthday parties or anniversary surprises. If you're specifically looking for a affordable private theater in Delhi for couples around Laxmi Nagar, the cosy setup makes it feel intimate without being overdone.

            <br />
            <br />
            {/* On the day of your event, simply arrive and enjoy a fully private
            screening experience with your loved ones—stream your favorite
            movies, TV shows, music videos, or even your own personal videos and
            photo slideshows on the big screen. Whether it’s a cozy movie night
            for two or a surprise celebration with friends and family, Cine
            Celebrate ensures complete privacy, comfort, and personalization. */}
            Once your private movie theater in delhi,  booking is confirmed, that’s where the fun part begins. You can add balloon decorations, LED light setups, happy birthday neon signs, photoshoots, cakes, food and beverage packages, or even personalised proposal settings. Since we’re known as one of the decorated private venues for celebration in Delhi NCR, we focus more on creating the right vibe rather than just adding décor for the sake of it.

            <br />
            <br />
            {/* Our team handles all setup and technicalities, so you can sit back,
            relax, and create unforgettable memories without stress. With
            affordable packages, quick online booking, and a growing list of
            happy guests, we’re redefining what it means to celebrate life’s
            moments. Discover the magic of private theater rentals—where you
            don’t just watch a movie, you make memories on the big screen. */}
            On the day of your event, you just arrive - everything else is already arranged. The private screening experience is completely yours. You can stream movies, TV shows, music videos, or even play your own photo slideshows and personal videos on the big screen. Whether it’s a quiet movie night for two or a surprise celebration with friends and family, the space stays fully private.
            <br />
            <br />
            Our team handles the setup and technical side quietly in the background so you don’t feel rushed or stressed. With affordable private theater rentals, flexible packages, and simple online booking, the whole process feels smooth from start to finish.
            <br />
            <br />
            At Cine Celebrate in Laxmi Nagar, Delhi, it’s not just about watching something on screen - it’s about making the moment feel special.
          </p>
        </div>
      </div>
      {/* <div className='new-how'>
    <div className='new-how-overlay'>
<h3>How does Private Theater Celebration work?</h3>
 <p>Planning your private theater celebration with The Cine Celebrate is simple and hassle-free. Start by selecting your preferred date and time, then choose from our customizable packages to suit your occasion. Whether it’s a birthday, date night, or anniversary, you can add personalized touches like décor, or even a photoshoot. On the day of your event, enjoy a seamless experience as you watch your favorite movies, shows, photos, or videos on the big screen,Sit back, relax, and let us take care of the details to make your celebration truly unforgettable!</p>

    </div>
    </div> */}
    </>
  );
}

export default HowPvt;
